import React, { useState } from 'react';
import LoadMore from './LoadMore';
import DetailModal from './DetailModal';
import useCutInfoHandler from './useCutInfoHandler';

export default function CutsList({ cutsList }) {
  const [
    cutInfo,
    cutInfoError,
    detailModal,
    cardClickHandler,
    closeModalHandler
  ] = useCutInfoHandler();

  const [limit, setLimit] = useState(12);
  let resultsRender = [];

  for (var index = 0; index < limit; index += 4) {
    resultsRender.push(
      <section key={index} className="section">
        <div className="container">
          <div className="grid grid--card">
            {cutsList.slice(index, index + 4).map((cut) => {
              const { image, image_alt, id, name } = cut;

              return (
                <article
                  key={id}
                  onClick={() => cardClickHandler(id)}
                  className="cut-card card grid__col-xs-12 grid__col-sm-6 grid__col-lg-3"
                >
                  <img
                    src={image ? image : ''}
                    className="card__media"
                    alt={image_alt ? image_alt : ''}
                  />
                  <h4 className="card__title u--text-align-center">{name}</h4>
                  <div className="cut-card__overlay">
                    <div className="btn btn--primary">Learn More</div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    );
  }

  return (
    <div id="cuts__list" className="cuts__list">
      {resultsRender}{' '}
      <LoadMore limit={limit} setLimit={setLimit} cutsList={cutsList} />{' '}
      {detailModal && (
        <DetailModal
          cutInfo={cutInfo}
          cutInfoError={cutInfoError}
          closeModalHandler={closeModalHandler}
        />
      )}
    </div>
  );
}
